import { render, staticRenderFns } from "./Place.vue?vue&type=template&id=01cd110c&"
import script from "./Place.vue?vue&type=script&lang=js&"
export * from "./Place.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports